// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17w1t","type":"styles_type__24-PZ","choices":"styles_choices__kMsOl"};